/* Local proof: the paths describe existing artwork, not new decoration.
   Black silhouettes remove only paper, exposing original scene/reveal pixels. */
(() => {
  const dataURL = new URL(document.currentScript.dataset.silhouettes || 'coloring-blanket-v6-4-silhouettes.json', document.currentScript.src);
  fetch(dataURL).then(response => {
    if (!response.ok) throw new Error('V6.4 silhouette data unavailable');
    return response.json();
  }).then(scenes => {
    for (const [id, art] of Object.entries(scenes)) {
      const scene = document.getElementById(id);
      const paper = scene?.querySelector('.paper');
      const image = scene?.querySelector('[data-scene-image]');
      if (!paper || !image) continue;
      let frame = 0;
      const update = () => {
        frame = 0;
        if (!image.complete || !image.naturalWidth || paper.dataset.paperState === 'minimized') return;
        // Fail closed if a future template replaces this particular drawing.
        if (!image.currentSrc.includes(art.asset)) {
          paper.style.removeProperty('--scene-paper-mask');
          delete paper.dataset.sceneOverlap;
          return;
        }
        const sceneBox = image.getBoundingClientRect();
        const paperBox = paper.getBoundingClientRect();
        if (!sceneBox.width || !paperBox.width) return;
        const surface = getComputedStyle(paper, '::before');
        const left = parseFloat(surface.left) || 0;
        const top = parseFloat(surface.top) || 0;
        const width = paperBox.width - left - (parseFloat(surface.right) || 0);
        const height = paperBox.height - top - (parseFloat(surface.bottom) || 0);
        // Match object-fit: cover, including its source-image crop.
        const scale = Math.max(sceneBox.width / art.width, sceneBox.height / art.height);
        const position = getComputedStyle(image).objectPosition.split(' ').map(value => parseFloat(value) / 100);
        const x = sceneBox.left - paperBox.left - left + (sceneBox.width - art.width * scale) * position[0];
        const y = sceneBox.top - paperBox.top - top + (sceneBox.height - art.height * scale) * position[1];
        const paths = art.paths.map(path => `<path d="${path.d}"/>`).join('');
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}"><rect width="100%" height="100%" fill="white"/><g fill="black" transform="translate(${x} ${y}) scale(${scale})">${paths}</g></svg>`;
        paper.style.setProperty('--scene-paper-mask', `url("data:image/svg+xml,${encodeURIComponent(svg)}")`);
        paper.dataset.sceneOverlap = 'aligned';
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      const observer = new ResizeObserver(schedule);
      [scene, image, paper].forEach(element => observer.observe(element));
      new MutationObserver(schedule).observe(paper, { attributes: true, attributeFilter: ['data-paper-state'] });
      image.addEventListener('load', schedule);
      window.addEventListener('resize', schedule, { passive: true });
      document.fonts.ready.then(schedule);
      schedule();
    }
  }).catch(error => console.warn(error.message));
})();
